import ReactHtmlParser from 'html-react-parser';

const Card = (props) => {
  const { title, text, link, image, accent, darkText, openMenu, contentMenu, index = 0 } = props;

  const isLink = typeof link === 'string';
  const buttonTextColor = darkText ? '#1c2620' : '#ffffff';
  // On light species fills the accent is too pale for body text, so titles
  // fall back to ink while the accent stays on the top bar and action button.
  const titleColor = darkText ? '#1c2620' : accent;

  const onButton = () => {
    if (contentMenu && openMenu) {
      contentMenu();
      openMenu();
    }
  };

  const img = (
    <div
      className="relative h-40 w-full overflow-hidden bg-moss-50"
      style={{ borderBottom: `3px solid ${accent}` }}
    >
      <img
        src={image}
        alt={title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />
    </div>
  );

  const button = (
    <button
      type="button"
      onClick={!isLink ? onButton : undefined}
      style={{ backgroundColor: accent, color: buttonTextColor }}
      className="mt-auto inline-flex h-10 w-full items-center justify-center gap-1.5 rounded-lg px-6 text-xs font-semibold uppercase tracking-[0.08em] shadow-sm transition-all duration-200 hover:brightness-110 hover:shadow-md focus:outline-none"
    >
      {isLink ? 'Open' : 'Open menu'}
      <span aria-hidden="true">{isLink ? '\u2192' : '\u22ef'}</span>
    </button>
  );

  return (
    <div
      style={{ borderTop: `3px solid ${accent}`, animationDelay: `${index * 50}ms` }}
      className="group flex animate-fade-up flex-col overflow-hidden rounded-2xl bg-white text-left shadow-soft ring-1 ring-moss-200/60 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lift"
    >
      {isLink ? (
        <a target="_blank" rel="noopener noreferrer" href={link}>
          {img}
        </a>
      ) : (
        <span onClick={onButton} className="cursor-pointer">
          {img}
        </span>
      )}
      <div className="flex flex-1 flex-col p-6">
        <h5
          style={{ color: titleColor }}
          className="mb-2 font-display text-xl font-semibold leading-snug"
        >
          {title}
        </h5>
        <div className="mb-5 text-sm leading-relaxed text-ink/70">
          {ReactHtmlParser(text)}
        </div>
        {isLink ? (
          <a target="_blank" rel="noopener noreferrer" href={link} className="mt-auto">
            {button}
          </a>
        ) : (
          button
        )}
      </div>
    </div>
  );
};

export default Card;
